import type { FaireProductEntity } from "../../entity_types/product";

export const p_ae5bduur6y: FaireProductEntity = {
  token: "p_ae5bduur6y",
  type: "product",
  name: "Light Pink Keshi Teardrops",
  brandToken: "b_d5ty4bqhca",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/9104c062e455e443139cbc3e38610fe47a097b896d56cb8df44243a2d782b624.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/432bf0ed1ace96b208c534a3a0a77c6399634b58425015146276547a2ccef6d2.jpeg",
    "https://cdn.faire.com/fastly/a5d0e456b321a40334c98375e6ffa1bd0526e6eff1ab26f1eaa3aa6ecb8612b4.jpeg",
    "https://cdn.faire.com/fastly/3621c47fe3f17b0ca5ff76d1b76bb8b1947008adfd0f14d51c43918801e22354.jpeg",
    "https://cdn.faire.com/fastly/cd958aa32d8a3771748ab47ce5cb58e83fa3e29a629afa686d0a2a9f1ef6b93b.jpeg",
    "https://cdn.faire.com/fastly/51a9fa3d29c4f373831585179a619e69fc31eaf0ba3bb79140d90856bdbac3f7.jpeg",
    "https://cdn.faire.com/fastly/fc3b2ac2dedd802ed2c21720eece10961ab6cc5e800209569a87970045eb557e.jpeg",
    "https://cdn.faire.com/fastly/1e523c885de9b5cbb91f0a8fb199779ed7a78add3f94cffed73744da04d10870.jpeg",
    "https://cdn.faire.com/fastly/58c280e1e6b1f80e5bd446de2a7a3a8167acc955596363df6a302bdaac9534a7.jpeg",
    "https://cdn.faire.com/fastly/ff8d006f07a36d45d35e3a6167bc12148117e55228933de160af09950d33d86d.jpeg",
  ],
  priceDollars: 18.5,
  description:
    "Dainty freshwater keshi pearls in a lovely pale pink dangle from 20g gold filled or sterling silver hammered teardrops.\n",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.155Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
